module.exports = __webpack_public_path__ + "static/assets/7d5856cb1fc9aba2ec4134627375dffc.png";